import { ICategoryType } from '@introspection/index';
import { Form, FormGroup } from '@rxdi/forms';
import { Component, html, LitElement, property } from '@rxdi/lit-html';
import { StudioModalFormStyles } from '@shared/styles/modal.styles';

import { InputErrorTemplate } from './input-error.template';

/** Modal body: create a blog category. */
@Component({
  selector: 'create-category-forms',
  styles: [StudioModalFormStyles],
  template(this: CreateCategoryFormComponent) {
    return html`
      <form
        name="create-category-forms"
        novalidate
        @submit=${async () => {
          const validity = await this.form.updateValueAndValidity();

          if (!validity?.length) {
            this.dispatchEvent(
              new CustomEvent<ICategoryType>('submitted', {
                detail: this.form.value,
              })
            );
          }
        }}
      >
        <header>
          <span class="kicker">Journal</span>
          <h2>New category</h2>
          <p>Categories group articles; only categories with articles show on the Journal page.</p>
        </header>
        <div class="body">
          <label>
            Name
            <input
              type="text"
              name="name"
              .disabled=${!!this.model?.name}
              minlength=${3}
              value=${this.model?.name ? this.model?.name : ''}
              required
            />
            ${InputErrorTemplate(this.form.get('name'))}
          </label>
          <label>
            Description
            <input
              type="text"
              name="description"
              .disabled=${!!this.model?.description}
              minlength=${3}
              value=${this.model?.description ? this.model?.description : ''}
              required
            />
            ${InputErrorTemplate(this.form.get('description'))}
          </label>
        </div>
        <footer>
          <button type="button" class="ghost" @click=${() => this.dispatchEvent(new CustomEvent('cancelled'))}>
            Cancel
          </button>
          <button type="submit" class="primary">Create category</button>
        </footer>
      </form>
    `;
  },
})
export class CreateCategoryFormComponent extends LitElement {
  @property({ type: Object })
  model: ICategoryType;

  @property({ type: Array })
  categories: ICategoryType[];

  @Form({
    name: 'create-category-forms',
    strategy: 'change',
    strict: true,
    // @rxdi/forms 0.7.243 reads options.customElements without a default
    customElements: [],
  })
  form = new FormGroup<ICategoryType>({
    name: ['', [this.validateExistingCategories]] as never,
    description: '',
  });

  OnUpdateFirst() {
    const model = this.model || {};
    Object.keys(model).map((key: never) => {
      if (this.form.get(key) && model[key]) {
        this.form.setValue(key, model[key]);
      }
    });
  }

  private validateExistingCategories(element: HTMLInputElement) {
    if (this.categories.find((c) => c.name === element.value)) {
      return {
        key: 'category-present',
        message: 'Category present! Please specify different category',
      };
    }
  }
}
